import React from "react";
import PropTypes from "prop-types";
import Table from "../Table";
import SizeInfo from "../SizeInfo";
import H from "../Typography/H";
import NoIndex from "../NoIndex";

import styles from "./size.module.scss";

function ProductSize(props) {
  const {title, content, withoutTitle} = props;
  return (
    <NoIndex>
      <div className={styles.root}>
        {!withoutTitle && <H level={2}>{title}</H>}
        {Array.isArray(content) ? (
          content.map(({title: tableTitle, table}) => (
            <div key={tableTitle} className={styles.table}>
              <H level={3}>{tableTitle}</H>
              <Table items={table} />
            </div>
          ))
        ) : (
          <div className={styles.table}>
            <Table items={content.table} />
          </div>
        )}
        <div className={styles.footer}>
          <div className={styles.norm}>Допустимая норма: ±2 см</div>
          {content.sizeInfo && <SizeInfo name={content.sizeInfo} />}
        </div>
      </div>
    </NoIndex>
  );
}

ProductSize.propTypes = {
  title: PropTypes.string,
  content: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
  withoutTitle: PropTypes.bool
};

export default ProductSize;
